export const sleep = async (millis: number): Promise<void> => {
	return new Promise((resolve) => {
		setTimeout(() => resolve(), millis);
	});
};

export const sleepUpTo = async (maxMillis: number): Promise<void> => {
	const [random] = crypto.getRandomValues(new Uint32Array(1));
	return sleep((random / 2 ** 32) * maxMillis);
};
